import { CommonModule } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ModalService } from "../../components/modal/service/modal.service";
import { CashbackFormComponent } from "./cashback-form/cashback-form.component";

import Swal from "sweetalert2";
import { Observable, Subscription } from "rxjs";
import {
  CashbackService,
  ReviewPurchaseAction,
} from "../../services/cashback.service";

@Component({
  selector: "app-cashback",
  imports: [CommonModule, RouterModule],
  templateUrl: "./cashback.component.html",
  styleUrl: "./cashback.component.scss",
})
export class CashbackComponent implements OnInit, OnDestroy {
  items$: Observable<any[]> | undefined;
  loading = false;
  error: string | null = null;
  private actionSubscription: Subscription | undefined;

  constructor(
    @Inject(CashbackService) public cashbackService: CashbackService,
    private modalService: ModalService
  ) {}

  ngOnInit() {
    this.loadFirstPage();
    this.actionSubscription = this.cashbackService.action$.subscribe(() => {
      this.loadFirstPage();
    });
  }

  ngOnDestroy() {
    if (this.actionSubscription) {
      this.actionSubscription.unsubscribe();
    }
  }

  loadFirstPage() {
    this.loading = true;
    this.error = null;

    try {
      this.items$ = this.cashbackService.getFirstPage();

      this.items$.subscribe({
        next: (data) => {
          this.loading = false;
          console.log("Cashbacks carregados:", data);
        },
        error: (error) => {
          this.loading = false;
          this.error = "Erro ao carregar cashbacks";
          console.error("Erro ao carregar cashbacks:", error);
        },
      });
    } catch (error) {
      this.loading = false;
      this.error = "Erro ao carregar cashbacks";
      console.error("Erro ao carregar primeira página:", error);
    }
  }

  nextPage() {
    if (!this.cashbackService.hasNextPage) return;

    this.loading = true;
    this.error = null;

    try {
      this.items$ = this.cashbackService.getNextPage();

      this.items$.subscribe({
        next: () => {
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
          this.error = "Erro ao carregar próxima página";
          console.error("Erro ao carregar próxima página:", error);
        },
      });
    } catch (error) {
      this.loading = false;
      this.error = "Erro ao carregar próxima página";
      console.error("Erro ao carregar próxima página:", error);
    }
  }

  prevPage() {
    if (!this.cashbackService.hasPreviousPage) return;

    this.loading = true;
    this.error = null;

    try {
      this.items$ = this.cashbackService.getPreviousPage();

      this.items$.subscribe({
        next: () => {
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
          this.error = "Erro ao carregar página anterior";
          console.error("Erro ao carregar página anterior:", error);
        },
      });
    } catch (error) {
      this.loading = false;
      this.error = "Erro ao carregar página anterior";
      console.error("Erro ao carregar página anterior:", error);
    }
  }

  openModal() {
    this.modalService.openModal(
      CashbackFormComponent,
      "Cadastro de Cashback",
      "modal-sm"
    );
  }

  verImagem(image: string) {
    if (!image) {
      Swal.fire({
        title: "Aviso",
        text: "Nenhuma imagem disponível",
        icon: "info",
      });
      return;
    }

    this.modalService.openModal(
      CashbackFormComponent,
      "Exibir comprovante",
      "modal-md",
      { image }
    );
  }

  trackByFn(index: number, item: any): any {
    return item?.id || index;
  }

  async aprovar(id: string) {
    await this.revisar(id, "approve");
  }

  async rejeitar(id: string) {
    await this.revisar(id, "reject");
  }

  private async revisar(id: string, action: ReviewPurchaseAction) {
    if (!id) return;

    const isApprove = action === "approve";
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: isApprove ? "btn btn-success" : "btn btn-danger",
        cancelButton: "btn btn-secondary",
      },
      buttonsStyling: false,
    });

    const result = await swalWithBootstrapButtons.fire({
      title: isApprove ? "Aprovar Cashback" : "Rejeitar Cashback",
      text: isApprove
        ? "Deseja realmente aprovar este cashback?"
        : "Deseja realmente rejeitar este cashback? O saldo reservado será estornado.",
      icon: isApprove ? "question" : "warning",
      showCancelButton: true,
      confirmButtonText: isApprove ? "Sim, aprovar!" : "Sim, rejeitar!",
      cancelButtonText: "Cancelar",
      reverseButtons: false,
    });

    if (!result.isConfirmed) return;

    try {
      await this.cashbackService.reviewPurchase(id, action);

      Swal.fire({
        title: isApprove ? "Aprovado!" : "Rejeitado!",
        text: isApprove
          ? "Cashback aprovado com sucesso."
          : "Cashback rejeitado com sucesso.",
        icon: "success",
      });
    } catch (error) {
      console.error(`Erro ao ${action} cashback:`, error);
      Swal.fire({
        title: "Erro!",
        text: isApprove
          ? "Erro ao aprovar cashback."
          : "Erro ao rejeitar cashback.",
        icon: "error",
      });
    }
  }
}
